import { useEffect, useState } from "react";
import MapLayer from "../../../models/mapLayer";
import ThematicMapLayerRange from "../../../models/thematicMapLayerRange";
import numberHelper from "../../../util/numberHelper";
import ThematicMapLayerFilters from "../../../models/thematicMapLayerFilters";

const ThematicMapLayerLegend: React.FC<{
  mapLayer: MapLayer;
  thematicMapLayerFilters: ThematicMapLayerFilters | undefined;
}> = ({ mapLayer, thematicMapLayerFilters }) => {
  const [ranges, setRanges] = useState<ThematicMapLayerRange[]>([]);

  useEffect(() => {
    if (!mapLayer.thematicMapLayer) {
      return;
    }

    let newRanges = [...mapLayer.thematicMapLayer.thematicMapLayerRanges];

    if (thematicMapLayerFilters) {
      const range = newRanges.find(
        (r) =>
          r.idThematicMapLayerRange ===
          thematicMapLayerFilters.thematicMapLayerRange?.idThematicMapLayerRange
      );
      if (range) {
        newRanges = [range];
      }
    } else {
      newRanges.sort((a: ThematicMapLayerRange, b: ThematicMapLayerRange) => {
        const isAsc = true;

        if (isAsc) {
          if (!a.hasRangeStart && b.hasRangeStart) {
            return -1;
          }

          if (a.hasRangeStart && !b.hasRangeStart) {
            return 1;
          }

          if (a.rangeStartValue < b.rangeStartValue) {
            return -1;
          }

          if (a.rangeStartValue > b.rangeStartValue) {
            return 1;
          }
        } else {
          if (!a.hasRangeStart && b.hasRangeStart) {
            return 1;
          }

          if (a.hasRangeStart && !b.hasRangeStart) {
            return -1;
          }

          if (a.rangeStartValue < b.rangeStartValue) {
            return 1;
          }

          if (a.rangeStartValue > b.rangeStartValue) {
            return -1;
          }
        }

        return 0;
      });
    }

    setRanges(newRanges);
  }, [mapLayer, thematicMapLayerFilters]);

  const getRangeDisplayValue = (rangeValue: number | undefined) => {
    const value = numberHelper.numberTo3Digits(rangeValue);
    return value;
  };

  return (
    <div
      style={{
        fontSize: "13px",
        display: "inline-block",
        backgroundColor: "rgba(255,255,255,.7)",
        padding: "10px",
        paddingRight: "14px",
      }}
    >
      <div className="d-flex">
        <div
          className="align-self-end"
          style={{
            marginBottom: "-4px",
            marginRight: "4px",
            fontWeight: "bold",
          }}
        >
          {mapLayer.layerName}
        </div>
        {ranges.map((range, index) => (
          <div
            className="d-flex flex-column align-items-center justify-content-end"
            style={{ position: "relative" }}
            key={index.toString()}
          >
            <div
              style={{
                position: "absolute",
                top: "0px",
                left: "0px",
                marginLeft: "-6px",
              }}
            >
              {getRangeDisplayValue(range.rangeStartDisplayValue)}
            </div>
            <div
              style={{
                paddingLeft: "10px",
                paddingRight: "10px",
              }}
            >
              {range.rangeLabel === "" && <span>&nbsp;</span>}
              {range.rangeLabel !== "" &&
                (range.hasRangeStart || range.hasRangeEnd) && (
                  <span
                    style={{
                      paddingLeft: "25px",
                      paddingRight: "25px",
                    }}
                  >
                    {range.rangeLabel}
                  </span>
                )}
              {range.rangeLabel !== "" &&
                !range.hasRangeStart &&
                !range.hasRangeEnd && <span>{range.rangeLabel}</span>}
            </div>
            <div>
              {index === ranges.length - 1 && (
                <div
                  style={{
                    position: "absolute",
                    top: "0px",
                    right: "0px",
                    marginRight: "-6px",
                  }}
                >
                  {getRangeDisplayValue(range.rangeEndDisplayValue)}
                </div>
              )}
            </div>
            <div
              style={{
                height: "10px",
                minWidth: "80px",
                width: "100%",
                background: range.rangeColor,
              }}
            ></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ThematicMapLayerLegend;
